<template>
  <div class="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden flex flex-col" :class="{ 'shrink-0': collapsed }">
    <!-- Header（可點擊收合）-->
    <button
      type="button"
      class="px-4 pt-3 pb-2 w-full text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-300 bg-gradient-to-b from-slate-50/50 to-transparent"
      :class="collapsed ? '' : 'border-b border-slate-100'"
      :aria-expanded="!collapsed"
      :aria-label="collapsed ? $t('permission_expand_aria') : $t('permission_collapse_aria')"
      @click="collapsed = !collapsed"
    >
      <div class="flex items-center gap-2">
        <v-icon size="16" color="#4f46e5">mdi-account-group</v-icon>
        <span class="text-sm font-bold text-slate-700">
          {{ $t('permission_user_list') }}
        </span>
        <div class="ml-auto inline-flex items-center justify-center min-w-[26px] h-[22px] px-2 rounded-full bg-indigo-500 text-white text-[11px] leading-none font-bold">
          {{ users.length }}
        </div>
        <v-icon size="16" color="#94a3b8">{{ collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
      </div>
    </button>
    <div v-show="!collapsed" class="px-4 pt-3 pb-2 border-b border-slate-100 bg-gradient-to-b from-slate-50/50 to-transparent">
      <div class="relative">
        <v-icon
          size="14"
          color="#94a3b8"
          class="absolute left-2.5 top-1/2 -translate-y-1/2"
        >
          mdi-magnify
        </v-icon>
        <input
          v-model="keyword"
          :placeholder="$t('permission_user_search_ph')"
          class="w-full text-xs pl-7 pr-3 py-2 rounded-lg bg-white border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-400 placeholder-slate-400 transition-colors"
        />
      </div>
    </div>

    <!-- List -->
    <ul v-show="!collapsed" class="overflow-y-auto py-1 user-list-scroll flex-1 min-h-0">
      <li
        v-for="u in filteredUsers"
        :key="u.Id"
        class="flex items-center gap-2.5 px-3 py-1.5 cursor-pointer border-l-2 transition-colors"
        :class="u.Id === selectedId
          ? 'bg-indigo-50 border-indigo-500'
          : 'border-transparent hover:bg-slate-50'"
        @click="$emit('select', u.Id)"
      >
        <div
          class="w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-semibold shrink-0"
          :class="u.Id === selectedId
            ? 'bg-indigo-500 text-white'
            : 'bg-slate-100 text-slate-500'"
        >
          {{ initialOf(u) }}
        </div>
        <div class="min-w-0 flex-1">
          <div
            class="text-[13px] truncate"
            :class="u.Id === selectedId ? 'font-semibold text-indigo-900' : 'font-medium text-slate-700'"
          >
            {{ displayName(u) }}
          </div>
          <div class="text-[10px] text-slate-400 font-mono truncate">{{ u.UserName }}</div>
        </div>
      </li>
      <li
        v-if="filteredUsers.length === 0"
        class="flex flex-col items-center py-10 text-slate-400"
      >
        <v-icon size="40" color="#cbd5e1">mdi-account-search-outline</v-icon>
        <div class="mt-2 text-xs">{{ $t('permission_query_no_users') }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { displayName, initialOf } from '@/js/permission-helpers'

export default {
  name: 'UserListPanel',
  props: {
    users: { type: Array, default: () => [] },
    selectedId: { type: String, default: null }
  },
  data () {
    return { keyword: '', collapsed: false }
  },
  computed: {
    filteredUsers () {
      const kw = this.keyword.trim().toLowerCase()
      if (!kw) return this.users
      return this.users.filter(u =>
        [displayName(u), u.UserName, u.Email]
          .filter(Boolean)
          .some(s => String(s).toLowerCase().includes(kw))
      )
    }
  },
  methods: { displayName, initialOf }
}
</script>

<style scoped>
.user-list-scroll::-webkit-scrollbar {
  width: 5px;
}
.user-list-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}
.user-list-scroll::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
